import React from 'react'
import AssignId from '../AssignId'
import Container from '../Container'
import VisibilitySensor from '../VisibilitySensor'
import Form from './Form'
import styles from './FormPage.module.sass'

export default function FormPage() {
    return (
        <div className={styles.root}>
            <Container>
                <VisibilitySensor index={8} />
                <div id='formPage' className={styles.content}>
                    <AssignId
                        id='contattaci'
                        absolute
                        y='-120px'
                        yMobile='-80px'
                    />
                    <div className={"scroll-fadein"}>
                        <h1 className={styles.title}>Contattaci</h1>
                        <div className={styles.description}>Partiamo con basi solide. Compila il form per richiedere tutte le informazioni.</div>
                    </div>
                    <Form />
                </div>
            </Container>
        </div>
    )
}
